import { Message } from "../generated-api-proxy";
import { Recommendation } from "../interfaces/recommendation";

export class SmartLink {

  public type: string = 'new';
  public text: string = 'Link';
  public url: string = '/';

  public static fromRecommendation(recommendation: Recommendation): SmartLink {
    const smartLink = new SmartLink();
    smartLink.type = recommendation.link_type;
    smartLink.text = recommendation.link_text;
    smartLink.url = recommendation.link_url;
    return smartLink;
  }

  //  create a similar static function, but with message instead
  public static fromMessage(message: Message): SmartLink {
    const smartLink = new SmartLink();
    smartLink.type = message?.['link_type'] ?? 'new';
    smartLink.text = message?.['link_text'] ?? "Link";
    smartLink.url = message?.['link_url'] ?? "/";
    return smartLink;
  }
}
